import { createSlice } from "@reduxjs/toolkit";
import { MembershipState } from "types/membership";
import { fetchMembershipThunk, fetchSubscriptionPlansThunk } from "./thunk";

export const initialState: MembershipState = {
    membership: {
        loading: false,
        error: null,
        data: null,
        last_fetched_at: 0
    },
    subscription_plans: {
        loading: false,
        error: null,
        data: null,
        last_fetched_at: 0
    }
}

const membershipSlice = createSlice({
    name: 'membershipState',
    initialState, 
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchMembershipThunk.pending, (state) => {
            state.membership.loading = true;
            state.membership.error = null;
        })
        .addCase(fetchMembershipThunk.fulfilled, (state, {payload}) => {
            state.membership.loading = false;
            state.membership.error = null;
            state.membership.data = payload.data;
            state.membership.last_fetched_at = payload.fetchedAt;
        })
        .addCase(fetchMembershipThunk.rejected, (state, {payload}) => {
            state.membership.loading = false;
            state.membership.error = payload || "Failed to fetch membership";
        })
        .addCase(fetchSubscriptionPlansThunk.pending, (state) => {
            state.subscription_plans.loading = true;
            state.subscription_plans.error = null;
        })
        .addCase(fetchSubscriptionPlansThunk.fulfilled, (state, {payload}) => {
            state.subscription_plans.loading = false;
            state.subscription_plans.error = null;
            state.subscription_plans.data = payload.data;
            state.subscription_plans.last_fetched_at = payload.fetchedAt;
        })
        .addCase(fetchSubscriptionPlansThunk.rejected, (state, {payload}) => {
            state.subscription_plans.loading = false;
            state.subscription_plans.error = payload || "Failed to fetch subscription plans";
        })
    }
})

export const {} = membershipSlice.actions;
export default membershipSlice.reducer;
